
import Vue from 'vue'
import Component from 'vue-class-component'
import imagesLoaded from 'imagesloaded'
import Isotope from 'isotope-layout'
import _ from 'lodash'
import { searchForSelector } from '@/utils/helpers'

@Component
export default class IsotopeMixin extends Vue {
  isotope: any = null
  isotopeWidth: string = ''
  isotopeImg: any = null
  container: any = null
  isotopeSection: string = '.isotope-section'

  initLayout () {
    return new Promise(resolve => {
      void searchForSelector(this.isotopeSection).then((element) => {
        this.container = element
        imagesLoaded(this.container, async () => {
          window.addEventListener('resize', this.setIsotopeWidth)

          this.setIsotopeWidth()

          this.isotope = new Isotope(this.container, {
            itemSelector: '.isotope-image',
            layoutMode: 'masonry'
          })

          await this.$nextTick()

          this.isotope.arrange()

          resolve()
        })

      })
    })
  }

  relayoutGrid (page: any) {
    return new Promise(resolve => {
      // consider if batchLoaded (from search results) if batchData changed?
      // this.destroyLayout() if search etc... to reorganize data..
      imagesLoaded(this.container, (instance: any) => {
        let appendedPhotos = document.querySelectorAll(`[data-page='${page}']`)

        if (this.isotope && this.isotope.insert) {
          this.isotope.insert(appendedPhotos)
          this.$nextTick(() => {
            this.isotope.arrange()
          })
        } else {
          void this.initLayout()
        }
        resolve()
      })
    })
  }

  public setIsotopeWidth (event?: any): any {
    this.isotopeImg = document.querySelector('.isotope-image')
    let container: any = document.querySelector('.isotope-section')
    let contentWidth = container.offsetWidth

    let isoImgStyle: any = window.getComputedStyle(this.isotopeImg)
    let marginLeft: string = isoImgStyle.getPropertyValue('margin-left')
    let marginRight: string = isoImgStyle.getPropertyValue('margin-right')
    let numDisplayedPhotos = 5

    if (contentWidth < 959) {
      numDisplayedPhotos = 3
    }

    if (contentWidth < 767) {
      numDisplayedPhotos = 2
    }
    // parseInt() radix is 10 (decimal)
    let totalMargin = (numDisplayedPhotos + 1) * (parseInt(marginLeft, 10) + parseInt(marginRight, 10))
    let columnWidth = Math.floor((contentWidth - totalMargin) / numDisplayedPhotos)

    this.isotopeWidth = columnWidth + 'px'
  }

  destroyLayout () {
    // Destroy the isotope instance
    if (this.isotope) {
      this.isotope.destroy()
      this.isotope = null
    }
  }

  beforeDestroy () {
    this.destroyLayout()
    window.removeEventListener('resize', this.setIsotopeWidth)
  }
}
